import { useCallback } from "react";
import Icon from "~/components/shared/Icon";
import { ControlButton, ControlPanel } from "~/components/Playground/Controls/ControlButton";

interface Props {
  hasExpandedGroups: boolean;
  onExpandAll: () => void;
  onCollapseAll: () => void;
}

export function GroupStepsControl({ hasExpandedGroups, onExpandAll, onCollapseAll }: Props) {
  const handleClick = useCallback(() => {
    if (hasExpandedGroups) {
      onCollapseAll();
    } else {
      onExpandAll();
    }
  }, [hasExpandedGroups, onExpandAll, onCollapseAll]);

  return (
    <ControlPanel>
      <ControlButton
        label={hasExpandedGroups ? "Collapse all groups" : "Expand all groups"}
        onClick={handleClick}
      >
        <Icon icon="heroicons/solid/chevron-up-down" className="h-4 w-5" />
      </ControlButton>
    </ControlPanel>
  );
}
